<div class="number-input-wrapper">
  <span class="number-input-cabs">{{label}}</span>
  <div class="number-input input-wrapper ">
  <!--   <button *ngIf="!disabled" class="input-icon minus-icon"><img src="assets/minus-circle.svg" (click)="decrement()"/></button>
    <input
    readonly
    class="input"
    type="number"
      [ngClass]="{'input-error': showError()}"
      [disabled]="disabled"
      (change)="inputChange()"
      (keyup)="inputChange()"
      [(ngModel)]="value"
      />
      <button *ngIf="!disabled" class="input-icon plus-icon"><img src="assets/plus-circle.svg" (click)="increment()"/></button> -->
      <!-- <button mat-icon-button>
        <mat-icon svgIcon="minus-circle"></mat-icon>
      </button> -->
      
      <mat-form-field appearance="outline" class=" input-form-field-height-32 number-input">
        <img src="../../../../assets/images/ic-action-remove-24.svg" (click)="decrement()" alt=""  [ngClass]="{'disableDropdown':lessThan1 || this.formControl?.disabled}">
        <!-- <mat-icon *ngIf="!disabled" matPrefix svgIcon="minus" (click)="decrement()"></mat-icon> -->
        <input 
        readonly
        class="input"
        type="number"
        matInput 
        [ngClass]="{'input-error': showError()}"
        [disabled]="disabled"
        (change)="inputChange()"
        (keyup)="inputChange()"
        [(ngModel)]="value">
        <img src="../../../../assets/images/ic-action-add-24.svg"  (click)="increment()" alt="" [ngClass]="{'disableDropdown':this.formControl?.disabled}">
        <!-- <mat-icon *ngIf="!disabled" matSuffix svgIcon="plus" (click)="increment()"></mat-icon> -->
      </mat-form-field>
    </div>
  <div class="error-msg" *ngIf="showError() && formControl.errors.required">{{errorMessages.required}}</div>
  <div class="error-msg" *ngIf="showError() && formControl.errors.pattern">{{ config.errorMessage || errorMessages.pattern}}</div>
</div>
